import { obterImplementosAsync } from "../../services/implementoService";

const atualizarImplementos = async ({ commit }) => {
    const implementos = await obterImplementosAsync();
    commit('atualizarImplementos', implementos);
}

const atualizarImplemento = ({ commit }, implemento) => {
    commit('atualizarImplemento', implemento);
}

export default {
    atualizarImplementos,
    atualizarImplemento
}